var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Title from '../../../atoms/Title';
import { VerticalGap } from '../../../atoms/Gap/Gap';
import CtaBtn from '../../../atoms/CtaBtn';
import { neutralDay, scc } from '@teamsparta/design-system';
import { BottomContents, MainContents } from '../../../../styles/_common.style';
import { useIsMobile } from '../../../../businessLogics/hooks';
var ChangeEmailDone = function (_a) {
    var setIsShow = _a.setIsShow;
    var isMobile = useIsMobile();
    var onClickCta = function () {
        setIsShow(false);
        window.location.reload();
    };
    return (_jsxs(_Fragment, { children: [_jsxs(MainContents, __assign({ paddingTop: 174, isCenterInMobile: true }, { children: [_jsx(Title, { children: "\uC774\uBA54\uC77C \uBCC0\uACBD \uC644\uB8CC!" }), !isMobile && (_jsxs(_Fragment, { children: [_jsx(VerticalGap, { size: 40 }), _jsx(CtaBtn, __assign({ bgColor: scc.red100, color: neutralDay.white, onClickAction: onClickCta }, { children: "\uB2EB\uAE30" }))] }))] })), isMobile && (_jsx(BottomContents, { children: _jsx(CtaBtn, __assign({ bgColor: scc.red100, color: neutralDay.white, onClickAction: onClickCta }, { children: "\uB2EB\uAE30" })) }))] }));
};
export default ChangeEmailDone;
//# sourceMappingURL=ChangeEmailDone.js.map